import { X } from 'lucide-react'

interface QueboardEntry {
  problem: any
  features: any
  tutorial: any
  character?: string
}

interface Props {
  open: boolean
  onClose: () => void
  entries: QueboardEntry[] | null
}

function pickInts(obj: any): { key: string; value: number }[] {
  if (!obj || typeof obj !== 'object') return []
  return Object.entries(obj)
    .filter(([, v]) => typeof v === 'number')
    .map(([key, v]) => ({ key, value: v as number }))
}

function pickTrueBooleans(obj: any): string[] {
  if (!obj || typeof obj !== 'object') return []
  return Object.entries(obj)
    .filter(([, v]) => v === true)
    .map(([k]) => k)
}

export function QueboardPreviewModal({ open, onClose, entries }: Props) {
  if (!open) return null
  const list = entries ?? []
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] flex flex-col">
        <header className="flex items-center justify-between px-5 py-3 border-b border-slate-200">
          <div>
            <h2 className="text-base font-semibold text-slate-900">깨보드 설정 미리보기</h2>
            <p className="text-xs text-slate-500">{list.length}개 수식</p>
          </div>
          <button onClick={onClose} className="p-1 rounded hover:bg-slate-100">
            <X className="w-5 h-5 text-slate-500" />
          </button>
        </header>
        <div className="flex-1 overflow-y-auto p-5 space-y-3">
          {list.length === 0 ? (
            <div className="py-10 text-sm text-center text-slate-400">데이터가 없습니다</div>
          ) : (
            list.map((entry, i) => {
              const problemParts = pickInts(entry.problem)
              const features = pickTrueBooleans(entry.features)
              const tutorialOn = entry.tutorial && entry.tutorial.enabled === true
              return (
                <div key={i} className="p-4 bg-white rounded-lg border border-slate-200 space-y-2">
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-mono text-fuchsia-600">#{i + 1}</span>
                    {problemParts.length > 0 && (
                      <span className="font-mono text-sm text-slate-800">
                        {problemParts.map(p => p.value).join(' · ')}
                      </span>
                    )}
                  </div>
                  {entry.character && (
                    <div className="text-xs">
                      <span className="text-slate-500">캐릭터:</span>{' '}
                      <span className="font-medium text-slate-700">{entry.character}</span>
                    </div>
                  )}
                  {features.length > 0 && (
                    <div className="flex flex-wrap gap-1">
                      {features.map(f => (
                        <span key={f} className="px-2 py-0.5 text-[10px] font-medium rounded bg-fuchsia-50 text-fuchsia-700">
                          {f}
                        </span>
                      ))}
                    </div>
                  )}
                  {tutorialOn && (
                    <span className="inline-block px-2 py-0.5 text-[10px] font-medium rounded bg-amber-50 text-amber-700">
                      튜토리얼 ON
                    </span>
                  )}
                </div>
              )
            })
          )}
        </div>
      </div>
    </div>
  )
}
